import React, { useState, useEffect } from 'react';
import '../styles/Header.css';

const benefits = [
    'reliable',
    'frequent',
    'accessible',
    'resilient',
    'sustainable',
    'innovative',
    'connected',
];

const BenefitAnimation = () => {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prevIndex) => (prevIndex + 1) % benefits.length);
        }, 2800); // Change text every 1.8 seconds

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="rolodex-container">
            <div className="rolodex">
                {benefits.map((benefit, i) => (
                    <div
                        key={i}
                        className={`benefit ${i === index ? 'showing' : ''}`}
                    >
                        {benefit}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BenefitAnimation;